export const useMobileByScreen = () => useNuxtApp().$isMobile
